import { removeItemfromArray } from '../../../functions/lists'

const ItemPerfomancesCheckbox = ({
    id,
    name,
    value,
    currentValue,
    label,
    onChange
}) => {
    return (
        <label className='checkbox-wrapper'>
            <input
                type="checkbox"
                checked={currentValue.includes(value)}
                onChange={() => {
                    let attributeArr = currentValue
                
                    if(attributeArr.includes(value)) {
                        attributeArr = removeItemfromArray(attributeArr, value)
                    } else {
                        attributeArr.push(value)
                    }

                    onChange(attributeArr)
                }}
            />
            <span className="text-small-regular">{label}</span>
        </label>
    )
}

export default ItemPerfomancesCheckbox